<template>
  <figure :class="$style.container">
    <a
      v-if="image"
      :class="$style.mediaLink"
      :href="secondaryLink"
      :target="secondaryLinkNewWindow ? '_blank' : '_self'"
    >
      <img :alt="category" :src="image" />
    </a>
    <figcaption>
      <div class="columns is-multiline">
        <a
          :class="[$style.secondaryLink, 'column']"
          :href="secondaryLink"
          :target="secondaryLinkNewWindow ? '_blank' : '_self'"
          >{{ category }}</a
        >
        <section
          v-for="(faq, index) in faqs"
          :key="index"
          :class="['column', faqs.length === 3 && $style.isRow]"
        >
          <h3>{{ faq.title }}</h3>
          <div>
            {{ faq.text }}
            <a
              v-if="faq.moreLink"
              :class="$style.more"
              :href="faq.primaryLink"
              :target="faq.primaryLinkNewWindow ? '_blank' : '_self'"
            >
              {{ moreLabel }}
              <i class="fas fa-chevron-right" />
            </a>
          </div>
        </section>
      </div>
    </figcaption>
  </figure>
</template>

<script setup>
import { onMounted, onUpdated, ref } from 'vue';
import { useStoreTranslations } from '../../store/translations/translations';

defineProps({
  faqs: {
    type: Array,
    default: () => [],
  },
  secondaryLink: {
    type: String,
    default: '',
  },
  secondaryLinkNewWindow: {
    type: Boolean,
    default: true,
  },
  category: {
    type: String,
    default: '',
  },
  image: {
    type: String,
    default: '',
  },
});

const moreLabel = ref(null);

const storeTranslations = useStoreTranslations();
const dictionaryMore = window.dictionary.more;

onMounted(() => {
  moreLabel.value = storeTranslations.translations?.['global.readMore'] || dictionaryMore;
});

onUpdated(() => {
  moreLabel.value = storeTranslations.translations?.['global.readMore'] || dictionaryMore;
});
</script>

<style module lang="scss">
@forward './FAQTeaser.scss';
</style>
